import {
  PaymentMeta,
  PersonalFinanceCategory,
  TransactionCode,
  TransactionCounterparty,
  TransactionPaymentChannelEnum,
  TransactionTransactionTypeEnum,
} from 'plaid'

export enum DataProvider {
  PLAID = 'PLAID',
  USER = 'USER',
}

export enum TransactionType {
  INCOME = 'INCOME',
  EXPENSE = 'EXPENSE',
}

export enum TransactionStatus {
  CATEGORIZED = 'CATEGORIZED',
  UNCATEGORIZED = 'UNCATEGORIZED',
}
export interface BalanceTransaction {
  cognitoId: string
  dataProvider: DataProvider
  balanceCategories?: SelectedCategory[] | undefined
  transactionType: TransactionType
  isTransfer: boolean
  amount: number
  name: string
  account_id: string
  iso_currency_code: string | null
  unofficial_currency_code: string | null
  category: string[] | null
  category_id: string | null
  check_number?: string | null | undefined
  date: string
  location: Location
  merchant_name?: string | null | undefined
  original_description?: string | null | undefined
  payment_meta: PaymentMeta
  pending: boolean
  pending_transaction_id: string | null
  account_owner: string | null
  transaction_id: string
  transaction_type?: TransactionTransactionTypeEnum | undefined
  logo_url?: string | null | undefined
  website?: string | null | undefined
  authorized_date: string | null
  authorized_datetime: string | null
  datetime: string | null
  payment_channel: TransactionPaymentChannelEnum
  personal_finance_category?: PersonalFinanceCategory | null | undefined
  transaction_code: TransactionCode | null
  personal_finance_category_icon_url?: string | undefined
  counterparties?: TransactionCounterparty[] | undefined
  lastUpdatedByProfileId?: string
  notes?: string | undefined
}

export interface SelectedCategory {
  categoryId: string
  amount: number
}

export type TransactionFilterType =
  | 'accounts'
  | 'type'
  | 'transfer'
  | 'status'
  | 'person'
  | 'dataProvider'
  | ''

export interface TransactionFilters {
  accounts?: string[] // account IDs
  type?: TransactionType // INCOME | EXPENSE
  transfer?: 'true' | 'false'
  status?: TransactionStatus // CATEGORIZED | UNCATEGORIZED
  person?: string // profileId
  dataProvider?: DataProvider // USER | PLAID
}
